import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-archivos',
  templateUrl: './archivos.component.html',
  styleUrls: ['./archivos.component.css']
})
export class ArchivosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
